
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[slug]/booking",
      function () {
        return require("private-next-pages/[slug]/booking/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[slug]/booking"])
      });
    }
  